import React from 'react'
import { toggleNav } from 'scripts/components/navigations/helpers/NavigationHelpers'
import { dispatcher } from '../NavigationDispatcher'
import { renderDropDown } from '../lists/ListNav'
import Constants from 'scripts/base/Constants'
import PropTypes from 'prop-types'

export default class DropDownList extends React.Component {
  constructor(props) {
    super(props)
    this.updateDom = this.updateDom.bind(this)
  }

  updateDom(data) {
    if (data.id === this.props.id) {
      toggleNav({ hidden: true, component: this }, data, this.props)
    }
  }

  componentDidMount() {
    dispatcher.on(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  componentWillUnmount() {
    dispatcher.off(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  renderChildren(item) {
    return renderDropDown(item, {
      listClasses: 'navbar-dropdown-item',
      aClasses: 'navbar-dropdown-link navbar-link',
      locale: this.props.locale
    })
  }

  render() {
    return (
      <ul className={`navbar-dropdown hidden`}>
        {this.props.navList.map(this.renderChildren.bind(this))}
      </ul>
    )
  }
}

DropDownList.propTypes = {
  id: PropTypes.string.isRequired,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string,
  navList: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/dropdowns/DropDownList.jsx